export default "__VITE_ASSET__8l7boxvw__"